module.exports = __webpack_public_path__ + "img/compliance-premium.2909da00.svg";